import React, {useState} from 'react'
import {ReactComponent as ExpandIcon} from 'assets/icons/dropdown.svg'
import styles from './ExpandableLayout.module.css'
import MatCollapse from '@material-ui/core/Collapse'
import classNames from 'classnames'

export function ExpandableLayout({collapsedHeight, children, expandedText, collapsedText, showExpandIcon, classes}) {
    const [opened, setOpened] = useState(false)

    const handleCollapse = () => setOpened(!opened)

    return (
        <>
            <MatCollapse in={opened}
                         collapsedHeight={collapsedHeight}>
                {children}
            </MatCollapse>
            {showExpandIcon && (
                <div className={classNames(styles.expanderBox, classes?.expanderBox)} onClick={handleCollapse}>
                    <span className={styles.expandText}>
                      {opened ? expandedText : collapsedText}
                    </span>
                    <ExpandIcon
                        className={
                            opened ? styles.expandIcon : styles.collapseIcon
                        }/>
                </div>
            )}
        </>
    )
}